require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';
import UserCan from "@/permissions";
import __ from './trans';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Generate Web Prices';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route, __, UserCan } })
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });
